import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstVe4: [],
		ve4: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, ve4){
			state.ve4 = ve4
			if (ve4)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.ve4 = null
		},
		setParamsDataTable(state, payload){
			state.lstVe4 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, ve4tipo){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/OryxPdv/SaleTypes/Find/${ve4tipo}`)
			.then(response => {
				let ve4 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", ve4)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.ve4.ve4tipo){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/OryxPdv/SaleTypes/Insert", store.state.ve4 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tipos-de-venda")
				store.state.ve4 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/OryxPdv/SaleTypes/Update", store.state.ve4 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tipos-de-venda")
				store.state.ve4 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/OryxPdv/SaleTypes/Delete/${store.state.ve4.ve4tipo}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tipos-de-venda")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/OryxPdv/SaleTypes/FindList")
			.then(response => {
				let lstVe4 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstVe4 = lstVe4
				store.state.hasNext = lstVe4.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstVe4 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/OryxPdv/SaleTypes/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstVe4 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}